// @flow
import $ from "../vendor/jquery";

import AngleChart from "./AngleChart";

import global, {menu_translate, clear_old_page, make_a_measurement_page} from "./Global";
import Settings from "./Settings";
import NominalGraph from "./NominalGraph";
import {activateMenuItem, is_numeric} from "../util";
import t from "../trans";
import Legacy from "../Legacy";
import ProductTransformer from "../ProductTransformer";

/**
 * Graafikute lehe joonistamise klass
 *
 */
class Graph {

    /**
     * @private
     * @type {?Graph}
     */
    static graphInstance = null;

    /**
     *
     * @returns {Graph}
     */
    static getInstance() {
        if (Graph.graphInstance == null) Graph.graphInstance = new Graph();
        return Graph.graphInstance;
    }

    constructor() {
        this.hoverTip = null;
        this.graph_height = 250;
        this.small_graph_height = 250;
        this.big_graph_height = 600;
        this.graph_width = 1200;
        // padding kahe graafiku vahel
        this.graph_padding = 30;
        // Hetkel zoomituna kuvatava graafiku number (0..n), -1 tähendab, et zoom on väljas
        this.zoomedGraph = -1;
        this.nominalButtonOn = false;
        this.current_plots = [null, null, null];
    }

    /**
     * Graafiku lehe tekitamine
     *
     * @param {number} [n]
     */
    make_graph_page(n) {
        menu_translate();
        clear_old_page();
        if (n == null || n < 0) {
            if (global.current_shown_wagon < 0) global.current_shown_wagon = global.current_wagon;
            n = global.current_shown_wagon;
        } else {
            global.current_shown_wagon = n;
        }
        this.show_analyze(n);
        //$("#content").html(s);
        $('.selectpicker').selectpicker();
        activateMenuItem("graph");
    }

    /**
     * Avatakse graafiku leht näidatud vaguni graafikuga
     * @param {number} n
     */
    goto_graph_page(n) {
        let settings = Settings.getInstance();

        this.nominalButtonOn = settings.getNominalGraph();
        this.make_graph_page(n);
    }

    /**
     * Funktsioon tagastab graafiku kõrguse, arvestades ekraani suurust ning kuvatavate graafikute arvu.
     */
    getGraphHeight(n) {
        let settings = Settings.getInstance();

        if (this.zoomedGraph == n) return this.big_graph_height;
        let graphCount = settings.getMeasurementLineCount();
        return Math.round((window.innerHeight - 100) / graphCount) - this.graph_padding;
    }

    show_analyze(n) {
        let settings = Settings.getInstance();

        this.zoomedGraph = -1;
        let s = "";
        let drow = Legacy.getDrow();
        if (drow) {
            if (!global.archive_mode) global.current_shown_wagon = n;

            //if (graph_mode) {
            s += "<span class='' id='wagonInfo' style='margin-bottom: 10px;'>";
            s += global.getWagonInfo(drow);
            s += "</span>";
            //}

            $("#topy").css("height", "50px");
            $("#intop2").css("margin-top", "10px");
            $("#intop2").css("margin-left", "40px");
            $("#intop2").html(s);
            s = this.make_analyze_buttons();
            $("#intop1").html(s);
            $(".mbtn").button("toggle");
            if (this.nominalButtonOn) {
                $("#mnb").addClass("active");
            }
            s = this.make_graphs(n);
            if (!global.archive_mode) $("#content").html(s);
            else {
                $("#a_measurement_content").html(s);

                let rowNo = (global.a_measurement ? global.a_measurement["rowNo"] : 0);
                if (rowNo > 0) $('#btnnavprev').css('visibility', 'visible');
                else $('#btnnavprev').css('visibility', 'hidden');
                if (rowNo < global.a_results.length - 1) $('#btnnavnext').css('visibility', 'visible');
                else $('#btnnavnext').css('visibility', 'hidden');
            }
            for (let i = 0; i < settings.getMeasurementLineCount(); i++) {
                // Set up clicking into graph:
                // s += "<div id='" + "graph" + nr + "' class='' style='" + gs + "' onclick=\"graph.show_single_graph('" + nr + "');\"></div>";
                let that = this;
                $('#graph' + i)
                    .mousemove(i, function (e) {
                        if (e.which == 1) {
                            $(this).data('move', true);
                        }
                    })
                    .mouseup(i, function (e) {
                        if (e.which == 1) {
                            if (!$(this).data('move')) {
                                that.show_single_graph(e.data);
                            }
                            $(this).data('move', false);
                        }
                    });
                this.draw_graph(drow, i);
            }
        }
    }

    make_analyze_buttons() {
        let settings = Settings.getInstance();

        let s = "";
        s += "<button class='btn btn-default graphbtn' onclick='graph.graph_refresh();'><span class='glyphicon glyphicon-refresh'></span></button>";
        s += "<span style='margin-right: 10px;'>&nbsp;</span>";
        if (!global.graph_mode) {
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_zoom_in();'><span class='glyphicon glyphicon-plus'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_zoom_out();'><span class='glyphicon glyphicon-minus'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_left();'><span class='glyphicon glyphicon-chevron-left'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_right();'><span class='glyphicon glyphicon-chevron-right'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_up();'><span class='glyphicon glyphicon-chevron-up'></span></button>";
            s += "<button class='btn btn-default graphbtn' onclick='graph.graph_pan_down();'><span class='glyphicon glyphicon-chevron-down'></span></button>";
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
        }

        //if (archive_mode) {
        //    s += "<button class='btn btn-default graphbtn mbtn' id='m2b'  onclick='graph.graph_toggle(2)'><span class='btntxt'>m2</span></button>";
        //    s += "<button class='btn btn-default graphbtn mbtn' id='m3b'  onclick='graph.graph_toggle(3)'><span class='btntxt'>m3</span></button>";
        //} else {
        //s += make_m_button(1);
        if (!settings.isSimpleUi() || global.archive_mode) {
            s += "<button class='btn btn-default graphbtn mbtn toggle' class-toggle='btn-inverse' id='m1b'  onclick='graph.graph_toggle(1)'><span class='btntxt'>m1</span></button>";
            s += this.make_m_button(2);
            s += this.make_m_button(3);
        } else {
            s += "<button class='btn btn-default graphbtn mbtn toggle hidden' class-toggle='btn-inverse' id='m1b'  onclick='graph.graph_toggle(1)'><span class='btntxt'>m1</span></button>";
        }
        //}
        if (!global.graph_mode) {
            s += "<button class='btn btn-default graphbtn rbtn' id='rawb'  onclick='graph.raw_toggle()'><span class='btntxt'>T</span></button>";
            s += '<button class="btn btn-default graphbtn" id="mnb"  onclick="graph.graph_toggle(\'n\')"><span class="btntxt">N</span></button>';
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
            s += '<button class="btn btn-default graphbtn" onclick="graph.graph_save_nominal()"><span class="btntxt">' + t("Save as nominal graph") + '</span></button>';
        } else {
            s += '<button class="btn btn-default graphbtn hide" id="mnb"><span class="btntxt">N</span></button>';
        }
        if (global.archive_mode) {
            // Kuvame navigeerimisnupud:
            let activeRow = -1;
            if (global.a_measurement && global.a_measurement["rowNo"] !== undefined) activeRow = global.a_measurement["rowNo"];

            s += "<span style='margin-right: 50px;'>&nbsp;</span>";
            s += "<button class='btn btn-primary graphbtn' onclick='graph.graph_select_item(-1);' id='btnnavprev'><span class='glyphicon glyphicon-chevron-left'></span>" + t('Previous') + "</button>";
            s += "<button class='btn btn-primary graphbtn' onclick='graph.graph_select_item(+1);' id='btnnavnext'><span class='glyphicon glyphicon-chevron-right'></span>" + t('Next') + "</button>";
            s += "<span style='margin-right: 10px;'>&nbsp;</span>";
            if (activeRow >= 0) s += "<span>" + (activeRow + 1) + " / " + global.a_results.length + "</span>\n";
        }

        return s;
    }

    make_m_button(n) {
        let s = '<div class="btn-group">';
        s += '<button type="button" class="btn btn-default mbtn" id="m' + n + 'b" onclick="graph.graph_toggle(' + n + ')"><span class="btntxt" id="m' + n + 't">m' + n + '</span></button>';
        s += '<button type="button" class="btn btn-default mbtn graphbtn dropdown-toggle" id="m' + n + 'bd" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">';
        s += '<span class="caret"></span>';
        // s += '<span class="sr-only">Toggle Dropdown</span>';
        s += '</button>';
        s += '<ul class="dropdown-menu">';
        s += '<li><a href="#" onclick="graph.graph_change_wagon(' + n + ', 0)">m' + n + '</a></li>';
        //s += '<li role="separator" class="divider"></li>';
        let data;
        if (global.archive_mode) {
            data = global.a_converted_results;
        }
        else {
            data = global.grid_data;
        }
        for (let i = 0; i < data.length; i++) {
            if (data[i])
                s += '<li><a href="#" onclick="graph.graph_change_wagon(' + n + ',' + (global.archive_mode ? i + 1 : i) + ')">' + (global.archive_mode ? "R" + (i + 1) : "W" + i) + ": " + global.getWagonTitle(data[i]) + '</a></li>';
        }
        s += '</ul></div>';
        return s;
    }

    make_graphs(n) {
        let settings = Settings.getInstance();
        let s = "";
        for (let i = settings.getMeasurementLineCount()-1; i >= 0; i--) {
            s += this.make_graph(n, i);
        }
        return s;
    }

    make_graph(n, nr) {
        let gs = "width: " + this.graph_width + "px; height: " + this.getGraphHeight(nr) + "px;";
        // gs += " min-height: " + "200" + "px;";
        gs += " min-height: 150px;";

        let s = '<div class="graph">';
        // s += "<div id='" + "graph" + nr + "' class='' style='" + gs + "' onclick=\"graph.show_single_graph('" + nr + "');\"></div>";
        s += "<div id='graph" + nr + "' class='' style='" + gs + "'></div>";
        s += "</div>";

        return s;
    }

    /**
     * Funkstioon värskendab kõikide graafikute sisud
     */
    refreshGraphs() {
        let settings = Settings.getInstance();
        $('#wagonInfo').html(global.getWagonInfo(Legacy.getDrow()));
        for (let n = 0; n < settings.getMeasurementLineCount(); n++) {
            this.drawGraph(n);
        }
    }

    /**
     * Funktsioon joonistab etteantud numbriga graafiku, kasutades sellele graafikule valitud vaguni numbrit ning serva numbrit.
     */
    drawGraph(nr) {

        //var wagonNr = $('#graphWagonSelect' + nr).val();
        //var edgeNr = $('#graphEdgeSelect' + nr).val();
        let drow = Legacy.getDrow();
        // Kui edgeNr === undefined, siis kasutab draw_graph selleks nr välja.
        this.draw_graph(drow, nr);
    }

    /**
     * Funktsioon lülitab kuvatavat graafikut suureks/väikeseks
     */
    show_single_graph(x) {
        let settings = Settings.getInstance();
        /*
        let drow;
        if (!global.archive_mode) {
            if (x >= global.grid_data.length) return;
            if (global.current_shown_wagon < 0) return;
            drow = global.grid_data[global.current_shown_wagon];
        } else {
            drow = global.a_measurement;
        }
        */

        if (this.zoomedGraph === x) this.zoomedGraph = -1;
        else this.zoomedGraph = x;

        for (let n = 0; n < settings.getMeasurementLineCount(); n++) {
            if (n == this.zoomedGraph || this.zoomedGraph === -1) {
                $("#graph" + n).css("height", this.getGraphHeight(n));
                $("#graph" + n).show();
                this.drawGraph(n);
            } else {
                $("#graph" + n).hide();
            }
        }
    }

    /*
    drawArrow: function (ctx, x, y, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y + radius);
        ctx.lineTo(x, y);
        ctx.lineTo(x - radius, y + radius);
        ctx.stroke();
    },*/

    /*drawSemiCircle: function (ctx, x, y, radius) {
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI, false);
        ctx.moveTo(x - radius, y);
        ctx.lineTo(x + radius, y);
        ctx.stroke();
        //console.log(l2+":"+u2);
    },*/

    draw_limit_u(ctx, x, y, radius) {
        //var d2=radius*3;
        ctx.beginPath();
        ctx.moveTo(x - radius, y);
        ctx.lineTo(x + radius, y);
        ctx.stroke();
    }

    draw_limit_d(ctx, x, y, radius) {
        //var d2=radius*3;
        ctx.beginPath();
        ctx.moveTo(x - radius, y);
        ctx.lineTo(x + radius, y);
        ctx.stroke();
    }

    tick_formatter(val, axis) {
        return val / 10 + ""; //val.toFixed(axis.tickDecimals);
    }


    /**
     * Graafiku joonestamine. Joonestab etteantud andmestiku baasilt graafiku.
     * @param {ConvertedMeasurementType} drow Graafiku andmestik
     * @param {number} graphNr Graafiku asukoha jrknr (0 - alumine, 1 - keskmine, 2 - ülemine)
     * @param {number} [line] joonistamiseks kasutatava mõõtmise number (0..2), vaikimisi võetakse sama, mis graphNr
     */
    draw_graph(drow, graphNr, line) {
        let nominalGraph = NominalGraph.getInstance();

        let linepoints, lineinfo, required, nominals, line_end, pointcount, rawstatus, rawnominals;
        let warn, np, wp, rn, serie, seriepoints, serieoptions;
        let minx, miny, maxx, maxy, colors, bid;
        let measurement_step, placeholder, l1, l2, slen;

        let nominalpoints;
        let adasPoint = null;
        let adasPointX = null;

        let LINE_START_X = 0;

        //if (graph_wagons[graphNr]) drow = Legacy.getDrow(graph_wagons[graphNr]);
        let drow2 = null;
        if (global.graph_wagons[2]) drow2 = Legacy.getDrow(global.graph_wagons[2]);
        let drow3 = null;
        if (global.graph_wagons[3]) drow3 = Legacy.getDrow(global.graph_wagons[3]);

        if (!drow) return;
        if (line === undefined) {
            line = graphNr;
        }

        lineinfo = drow.lineinfo;
        linepoints = drow["linepoints"];
        required = drow["corr_required"];
        //required=drow["required"];
        /*
        Legacy.debug("linepoints");
        Legacy.debug(linepoints);
        Legacy.debug("required");
        Legacy.debug(required);
        Legacy.debug("corr_shifts");
        Legacy.debug(drow["corr_shifts"]);
        */
        if (!linepoints || !required || !drow["corr_shifts"] || !drow["series"][line]) return;
        nominals = [];
        rawnominals = [];
        warn = [];
        // fetch required values for the nominals and combine with distances
        for (let x = 0; x < linepoints.length && x < required.length && x < lineinfo.length; x++) {
            if (lineinfo[x][0] != line) continue;

            line_end = drow["lineends"][line];
            np = [line_end - linepoints[x], required[x][0], required[x][1], required[x][2]];
            nominals.push(np);
            wp = [line_end - linepoints[x], required[x][0], required[x][3], required[x][4]];
            warn.push(wp);
            rn = [line_end - linepoints[x], drow["required"][x][0]];
            //Legacy.debug(x); 0 1 2 ... 8
            //if (x != 1 && x != 4 && x != 7) rawnominals.push(rn);
            if (!ProductTransformer.isCenterPoint(lineinfo[x][1])) rawnominals.push(rn);

            if (lineinfo[x][2]) {
                // See on ADAS akna punkt, selle koha peale tuleb joonistada püstine sinine joon
                adasPointX = line_end - linepoints[x];
                adasPoint = x;
            }

        }
        //Legacy.debug(nominals);
        let nominals_options = {
            show: true,
            radius: 3,
            errorbars: "y",
            yerr: { show: true, radius: 4, asymmetric: true, upperCap: this.draw_limit_u, lowerCap: this.draw_limit_d }
        };
        let warn_options = {
            show: true,
            radius: 3,
            errorbars: "y",
            yerr: { show: true, radius: 4, asymmetric: true, upperCap: this.draw_limit_u, lowerCap: this.draw_limit_d }
        };
        // fetch measurement series values
        seriepoints = [];
        serieoptions = [];
        serie = [];
        if (drow["corr_series"] && drow["corr_series"].length > line) {
            if ($("#rawb").hasClass('active') && drow["rawdata"]) {
                if (!drow["rawdata"][line]) return;
                rawstatus = true;
                serie = [drow["rawdata"][line]];
                //Legacy.debug("serie of len "+serie.length);
                //Legacy.debug(serie);
                slen = 1;
            } else {
                rawstatus = false;
                //serie = drow["corr_series"][line].slice(0);    // select serie for the given line
                serie = [];

                if (drow["corr_series"][line] && drow["corr_series"][line][0]) serie.push(drow["corr_series"][line][0]);

                if (drow2) {
                    if (drow2["corr_series"] && drow2["corr_series"][line] && drow2["corr_series"][line][0]) serie.push(drow2["corr_series"][line][0]);
                } else if (drow["corr_series"][line] && drow["corr_series"][line][1]) serie.push(drow["corr_series"][line][1]);

                if (drow3) {
                    if (drow3["corr_series"] && drow3["corr_series"][line] && drow3["corr_series"][line][0]) serie.push(drow3["corr_series"][line][0]);
                } else if (drow["corr_series"][line] && drow["corr_series"][line][2]) serie.push(drow["corr_series"][line][2]);

                slen = serie.length;
            }
            // loop over three (max) tries in each serie

            for (let v = 0; v < slen; v++) {
                if (rawstatus) pointcount = drow["rawdata"][line].length;
                else pointcount = serie[v].length;
                measurement_step = (drow["lineends"][line] - LINE_START_X) / pointcount;
                let x = 0;
                np = [];
                for (let i = 0; i < serie[v].length; i++) {
                    np.push([x, serie[v][i]]);
                    x += measurement_step;
                }
                seriepoints.push(np);
                let opts = {
                    show: true,
                    lines: { show: true },
                    points: { show: true },
                    radius: 2
                };
                serieoptions.push(opts);
            }
        }

        // Leiame nominaalgraafiku:
        if ($("#mnb").hasClass("active")) {
            if ((drow['codeVariant'] == nominalGraph.productNo) && nominalGraph.points != null && nominalGraph.points.length > line) {
                // Nominaalgraafik on juba sisse laetud:
                nominalpoints = [];
                let x = 0;
                for (let i = 0; i < nominalGraph.points[line].length; i++) {
                    nominalpoints.push([x, nominalGraph.points[line][i]]);
                    x += measurement_step;
                }
            } else {
                // Laeme nominaalgraafiku sisse:
                nominalGraph.load(drow.codeVariant);
                nominalpoints = null;
            }
        }

        // get max and min vals for the area
        minx = 0; miny = -90;
        maxx = -100000; maxy = -100000;
        for (let i = 0; i < warn.length && i < 3; i++) {
            if (warn[i][0] > maxx) maxx = warn[i][0];
            if (warn[i][1] > maxy) maxy = warn[i][1];
            if (warn[i][1] < miny) miny = warn[i][1];
        }
        for (let v = 0; v < seriepoints.length; v++) {
            for (let i = 0; i < seriepoints[v].length; i++) {
                if (seriepoints[v][i][0] > maxx) maxx = seriepoints[v][i][0];
                if (seriepoints[v][i][1] > maxy) maxy = seriepoints[v][i][1];
                if (seriepoints[v][i][1] < miny) miny = seriepoints[v][i][1];
            }
        }

        if (nominalpoints) {
            for (let i = 0; i < nominalpoints.length; i++) {
                if (nominalpoints[i][0] > maxx) maxx = nominalpoints[i][0];
                if (nominalpoints[i][1] > maxy) maxy = nominalpoints[i][1];
                if (nominalpoints[i][1] < miny) miny = nominalpoints[i][1];
            }
        }
        maxy = Math.floor(maxy + ((maxy - miny) * 0.1));
        // miny = Math.floor(miny - ((maxy - miny) * 0.1));
        if (miny > -100) miny -= 10;
        else miny = Math.floor(miny - ((maxy - miny) * 0.1));
        // maxx=Math.floor(maxx+((maxx-minx)*0.1));
        let data = [];
        if (!rawstatus) {
            data.push({ color: "#ff8000", points: warn_options, data: warn });  // label: "nb!"
            data.push({ color: "green", points: nominals_options, data: nominals });    // label: "ok"
        }
        // Nominaalgraafiku kuvamine:
        if ($("#mnb").hasClass("active") && !rawstatus && nominalpoints) {
            // Kuvame nominaalgraafiku
            data.push({
                color: "#FFFF00",
                points: {
                    show: true,
                    lines: {
                        show: true
                    },
                    points: { show: true },
                    radius: 2
                },
                data: nominalpoints,
                lines: {
                    show: true,
                    lineWidth: 2
                },
                label: "N",
                shadowSize: 3
            });
        }

        // loop backwards from the last series
        colors = [
            "#0000ff",
            "#6666ff",
            "#aaaaff"
        ];
        for (let c = 0, n = seriepoints.length - 1 ; n >= 0 && c < 3 ; n--, c++) {
            bid = "#m" + (n + 1) + "b";
            //Legacy.debug(bid);
            //Legacy.debug($(bid).hasClass("active"));
            if (!seriepoints || seriepoints[n].length < 10) continue;
            if (!rawstatus && !($(bid).hasClass("active"))) continue; // do not show if button not active
            let serieLabel = "m" + (n + 1);
            if (seriepoints.length == 1) serieLabel = '';
            if (n == 1 && drow2) serieLabel = (global.archive_mode ? "R" : "W") + global.graph_wagons[2] + ": " + global.getWagonTitle(drow2);
            if (n == 2 && drow3) serieLabel = (global.archive_mode ? "R" : "W") + global.graph_wagons[3] + ": " + global.getWagonTitle(drow3);
            data.push({
                color: colors[c], points: serieoptions[n], data: seriepoints[n],
                lines: { show: true, lineWidth: 2 },
                label: serieLabel,
                shadowSize: 3
            });
        }
        // show non-normalized tolerances
        if (!rawstatus) {
            data.push({
                color: "#ff0000", data: rawnominals,
                //  [[0,0],[10,0.2],[50,1],[100,4],[150,4.5],[200,10],[300,20]],
                lines: { show: false, lineWidth: 1 }, points: { show: true, radius: 2 },
                label: null, shadowSize: 3
            });
        }

        let adasPointMarkings = null;
        if (adasPoint != null) {
            adasPointMarkings = [
                { color: "#6666ff", lineWidth: 3, xaxis: { from: adasPointX, to: adasPointX }}
            ];
        }

        // plot stuff
        let plotOptions = {
            grid: {
                // backgroundColor: "white"
                // clickable: true,
                hoverable: true,
                autoHighlight: true
            },
            xaxis: {
                min: minx,
                max: maxx,
                position: "bottom",
                tickFormatter: this.tick_formatter
            },
            yaxis: {
                min: miny,
                max: maxy,
                /* tickLength: 0, */
                tickSize: 100,
                tickFormatter: this.tick_formatter,
                transform: function (v) { return -v; },
                inverseTransform: function (v) { return -v; }
            },
            zoom: {
                // Set true to enable zoom with mouse
                interactive: true
            },
            pan: {
                // Set true to enable pan with mouse
                interactive: true
            },
            legend: {
                show: true,
                /*
                labelFormatter: null or (fn: string, series object -> string)
                labelBoxBorderColor: color
                noColumns: number
                position: "ne" or "nw" or "se" or "sw"
                margin: number of pixels or [x margin, y margin]
                backgroundColor: null or color
                backgroundOpacity: number between 0 and 1
                container: null or jQuery object/DOM element/jQuery expression
                */
                position: "nw",
                backgroundOpacity: 0.1,
            }
        };
        if (!rawstatus) {
            plotOptions.grid.markings = adasPointMarkings;
        }
        let current_plot = $.plot("#graph" + graphNr, data, plotOptions);
        this.current_plots[graphNr] = current_plot;

        placeholder = $("#graph" + graphNr);
        //placeholder.append("<div style='position:absolute;left:" + (o.left + 4) + "px;top:" + o.top + "px;color:#666;font-size:smaller'>Warming up</div>");
        l1 = "E" + (line*2+1);
        l2 = "E" + (line*2+2);
        //if (line == 0) { l1 = "E1"; l2 = "E2" }
        //else if (line == 1) { l1 = "E3"; l2 = "E4" }
        //else if (line == 2) { l1 = "E5"; l2 = "E6" };
        placeholder.append("<div style='position:absolute;left:" + 0 + "px;top:" + 30 + "px;color:#f00;'>" + l1 + "</div><div style='position:absolute;left:" + (1198) + "px;top:" + 30 + "px;color:#f00;'>" + l2 + "</div>");

        // Lisame NURK gauge:
        if (!rawstatus && graphNr == 1 && drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
            let angleChart = new AngleChart("graph"+graphNr, "angleChart", drow.angles[0]);
            angleChart.setValue(drow.analyzed_angles[0][2]);
        }

        // graph.html lehel kuvatakse keskel kast:
        if (global.graph_mode && drow["analyzed"]) {
            // Teeme graafiku keskele üles serva kasti, mis näitab värviga keskmise punkti täpsust
            // Leiame keskmise punkti väärtuse:
            placeholder.append(this.getGraphBox(drow, "middle", graphNr*3 + 1));

            // ADAS punkti kast:
            if (adasPoint) {
                placeholder.append(this.getGraphBox(drow, "adas", adasPoint));
            }
        }

        $('#graph' + graphNr).on('plothover', function (event, pos, item) {
            //console.log("hover recognized");
            if (this.hoverTip) this.hoverTip.remove();
            if (item) {
                this.hoverTip = $(this.toolTipHTML(item.series.data[item.dataIndex][1], item.series.label));
                if (this.hoverTip) {
                    $('.graph').parent().append(this.hoverTip);
                    let ofsh = this.hoverTip.outerHeight();
                    let ofsw = this.hoverTip.outerWidth();
                    this.hoverTip.offset({
                        left: item.pageX - ofsw / 2,
                        top: item.pageY - ofsh - 15
                    });
                }
            }
        }.bind(this));

    }

    /**
     * Tagastab graafikule kasti, mille värv vastab antud punktiga määratud tolerantisvahemikule.
     * Kasti asukoht sõltub id parameetrist
     * @param {ConvertedMeasurementType} drow Mõõteinfo struktuur
     * @param {string} id Punkti liik: "middle" või "adas"
     * @param point
     * @returns {string}
     */
    getGraphBox(drow, id, point) {
        let boxStyle = 'middleBoxRed';
        switch (drow["analyzed"][point][1]) {
            case 3: // Punane
                boxStyle = 'middleBoxRed';
                break;
            case 2: // Kollane
                boxStyle = 'middleBoxYellow';
                break;
            case 1: // Roheline
                boxStyle = 'middleBoxGreen';
                break;
            default:
                break;
        }

        let position = "";
        switch (id) {
            case "middle":
                // center
                position = "left:" + (10 + 600 - 80 / 2) + "px;top:" + 8 + "px;";
                break;
            case "adas":
                // [ceneter, 150] keskele:
                position = "left:" + (10 + 600 + 600/2 - 150/2+10 - 80 / 2) + "px;top:" + 8 + "px;";
                break;
            default:
                break;
        }

        return "<div id='"+id+"PointBox' class='" + boxStyle + "' style='position:absolute;" + position + "width:80px;height:40px'></div>";
    }

    toolTipHTML(a, b) {
        let s, x;
        if (!is_numeric(a)) return false;
        x = Math.round(a * 10) / 100;
        s = "<i>" + x + "</i>";
        return s;
    }

    graph_refresh() {
        let settings = Settings.getInstance();
        this.nominalButtonOn = settings.getNominalGraph();
        this.make_graph_page();
    }

    graph_zoom_in() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].zoom();
    }

    graph_zoom_out() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].zoomOut();
    }

    graph_pan_left() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].pan({ left: 100, top: 0 });
    }

    graph_pan_right() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].pan({ left: -100, top: 0 });
    }

    graph_pan_up() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].pan({ right: 0, top: 50 });
    }

    graph_pan_down() {
        for (let l = 0; l < this.current_plots.length; l++) this.current_plots[l].pan({ right: 0, top: -50 });
    }

    graph_select_item(n) {
        let activeRow = -1;
        if (global.a_measurement && global.a_measurement["rowNo"] !== undefined) activeRow = global.a_measurement["rowNo"];
        activeRow += n;
        if (activeRow >= 0 && activeRow < global.a_results.length) this.show_a_measurement(activeRow);
    }

    show_a_measurement(r) {
        Legacy.debug(r);
        global.a_measurement = global.a_converted_results[r];
        global.a_measurement["rowNo"] = r;
        Legacy.debug(global.a_measurement);
        make_a_measurement_page();
    }

    graph_toggle(m) {
        let status;
        let id = '#m' + m + 'b';
        //console.log("graph_toggle "+m+" id "+id);
        status = $(id).hasClass('active');
        $(id).button("toggle");
        $(id + 'd').button("toggle");
        if (status) {
            // Väljalülitamine
            $(id).css("background-color", "white");
            $(id + 'd').css("background-color", "white");
        } else {
            // Sisselülitamine
            $(id).css("background-color", "999999");
            $(id + 'd').css("background-color", "999999");
        }

        //$(id).css("background-color","yellow");
        //console.log($(id).hasClass('active'));
        if (m == "n") {
            let nominalGraph = NominalGraph.getInstance();
            this.nominalButtonOn = !status;
            if (status) {
                // Lülitame nominaalgraafiku välja:
                this.refreshGraphs();
            } else {
                // Laeme nominaalgraafiku sisse
                let drow = Legacy.getDrow();
                // load() kutsub ise refreshGraphs() välja!
                nominalGraph.load(drow.codeVariant);
                this.refreshGraphs();
            }
        }
        else this.refreshGraphs();
    }

    graph_change_wagon(n, w) {
        global.graph_wagons[n] = w;
        if (global.archive_mode) {
            if (w > 0) $('#m' + n + 't').text("R" + w);
            else $('#m' + n + 't').text("m" + n);
        } else {
            if (w > 0) $('#m' + n + 't').text("W" + w);
            else $('#m' + n + 't').text("m" + n);
        }
        this.refreshGraphs();
    }

    graph_save_nominal() {
        let nominalGraph = NominalGraph.getInstance();
        //let points = [];
        let drow = Legacy.getDrow();
        if (!drow) return;
        let series = drow.corr_series;
        if (!series) return;
        nominalGraph.save(drow['codeVariant'], series);
    }

    raw_toggle() {
        let id = '#rawb';
        let status = $(id).hasClass('active');
        $(id).button("toggle");
        if (status) $(id).css("background-color", "white");
        else $(id).css("background-color", "999999");
        this.refreshGraphs();
    }
}

export default Graph;
